module.exports = __webpack_public_path__ + "static/img/recondo-3.ffdeb63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/recondo-3.jpg
// module id = Q473
// module chunks = 1